import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M22.625 14a.625.625 0 0 1-1.25 0V8.509l-6.802 6.801c-.19.191-.36.361-.511.49a1.653 1.653 0 0 1-.56.33 1.624 1.624 0 0 1-1.004 0 1.653 1.653 0 0 1-.56-.33c-.151-.129-.32-.299-.511-.49l-2.738-2.737a8.411 8.411 0 0 0-.436-.42.495.495 0 0 0-.137-.095.377.377 0 0 0-.232 0 .495.495 0 0 0-.137.095 8.416 8.416 0 0 0-.436.42l-4.869 4.87a.626.626 0 0 1-.884-.885l4.869-4.868c.19-.191.36-.361.511-.49.158-.133.336-.258.56-.33a1.624 1.624 0 0 1 1.004 0c.224.072.402.197.56.33.151.129.32.299.511.49l2.737 2.737c.206.205.333.332.437.42a.497.497 0 0 0 .137.095.377.377 0 0 0 .232 0 .5.5 0 0 0 .137-.095 8.72 8.72 0 0 0 .436-.42l6.801-6.802H15a.625.625 0 1 1 0-1.25h7c.345 0 .625.28.625.625v7Z"
    />
  </svg>
`;
